"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nprogress_1 = __importDefault(require("nprogress"));
const postGuard = function () {
    nprogress_1.default.done();
};
exports.default = postGuard;
